import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { MapContainer, TileLayer, Polyline, Marker, Popup, Tooltip } from 'react-leaflet';
import React, { useState, useRef, useEffect, useMemo} from "react";
import { CABLE_FLAG, COUPLING_FLAG, FOB_FLAG, icon100pab, iconCoupling, iconCouplingCanton, iconFob, iconFobCanton, iconManhole, iconPillar, iconPonBox, iconProblem, PILLAR_FLAG, PON_BOX_FLAG, WELL_FLAG  } from '../Constants/ConstantsOptics';
import './styleModal.css';
import { GET_RUOTE_CABLE_CONNECTION_API_URL } from '../OpticApiConfig';
import L from "leaflet";
import { getDistanceOnLine } from './GeoDistance';

const ModalRouteCableMap = ({ open, onClose }) => {

  const mapRef = useRef();
 

  const [listConnectionCable, setListConnectionCable] = useState([]);
  const [fobLocations, setFobLocations] = useState([]); 
  const [couplingLocations, setCouplingLocations] = useState([]); 
  const [wellLocations, setWellLocations] = useState([]); 
  const [ponBoxLocations, setPonBoxLocations] = useState([]); 
  const [pillarLocations, setPillarLocations] = useState([]); 
  const [inputId, setInputId] = useState('');
  const [problemLineLocations, setProblemLineLocations] = useState([]); 
  const [totalLength, setTotalLength] = useState(0);
  const [clickedPointInfo, setClickedPointInfo] = useState(null);



  const fetchData = async () => {
    setListConnectionCable([]);
    setFobLocations([]);
    setCouplingLocations([]);
    setWellLocations([]);
    setPonBoxLocations([]);
    setPillarLocations([]);
    setProblemLineLocations([]);
    
      const token = localStorage.getItem('token');
      if (!token) {
          console.log('Ошибка! Токен не найден');
          return;
      }

      try {
          const response = await fetch(`${GET_RUOTE_CABLE_CONNECTION_API_URL}?highwayLineId=${inputId}`, {
              method: 'GET',
              headers: {
                  'Authorization': `Bearer ${token}`
              }
          });

         
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }

          const data = await response.json();

          if (data && data.value) {
              setListConnectionCable(data.value.listLineOpticHighwayCoordinate);
             

              const fobLocations = [];
              const couplingLocations = [];
              const wellLocations = [];
              const ponBoxLocations = [];
              const pillarLocations = [];   
              
           // const firstCoordinate = data.value.listLineOpticHighwayCoordinate[0]?.coordinates[0];
           const firstCoordinate = data.value.listLineOpticHighwayCoordinate.at(-1)?.coordinates.at(-1);
            if (firstCoordinate && mapRef.current) {
                mapRef.current.setView([firstCoordinate.latitude, firstCoordinate.longitude], 16); 
            }

              data.value.result.forEach(item => {
                  if (item.fobLocation) {
                      fobLocations.push({
                          id: item.id,
                          latitude: item.fobLocation.latitude,
                          longitude: item.fobLocation.longitude,
                          description: item.fobLocation.description,
                          fobName: item.fobLocation.fobName,
                          rankComponentId: item.fobLocation.rankComponentId,
                          territory: [item.fobLocation.city, item.fobLocation.canton, item.fobLocation.region, item.fobLocation.area]
                          .filter(Boolean) 
                          .join(' / ')
                      });
                  }
                  if (item.couplingLocation) {
                      couplingLocations.push({
                          id: item.id,
                          latitude: item.couplingLocation.latitude,
                          longitude: item.couplingLocation.longitude,
                          description: item.couplingLocation.description,
                          couplingName: item.couplingLocation.couplingName,
                          rankComponentId: item.couplingLocation.rankComponentId,
                          territory: [item.couplingLocation.city, item.couplingLocation.canton, item.couplingLocation.region, item.couplingLocation.area]
                          .filter(Boolean) 
                          .join(' / ') 
                      });
                  }
                  if (item.well) {
                      wellLocations.push({
                          id: item.id,
                          latitude: item.well.latitude,
                          longitude: item.well.longitude,
                          description: item.well.description,
                          ownerWell: item.well.ownerWellName,
                          territory: [item.well.city, item.well.canton, item.well.region, item.well.area]
                          .filter(Boolean) 
                          .join(' / ') 
                      });
                  }
                  if (item.ponBox) {
                    ponBoxLocations.push({
                        id: item.id,
                        latitude: item.ponBox.latitude,
                        longitude: item.ponBox.longitude,
                        description: item.ponBox.description,
                        ponBoxName: item.ponBox.ponBoxName,
                        territory: [item.ponBox.city, item.ponBox.canton, item.ponBox.region, item.ponBox.area]
                        .filter(Boolean) 
                        .join(' / ') 
                    });
                }
                if (item.pillar) {
                  pillarLocations.push({
                      id: item.id,
                      latitude: item.pillar.latitude,
                      longitude: item.pillar.longitude,
                      description: item.pillar.description,
                      ownerPillar: item.pillar.ownerPillarName,
                      territory: [item.pillar.city, item.pillar.canton, item.pillar.region, item.pillar.area]
                      .filter(Boolean) 
                      .join(' / ') 
                  });
              }
              });
  
              // Сохраняем массивы в state
              setFobLocations(fobLocations);
              setCouplingLocations(couplingLocations);
              setWellLocations(wellLocations);
              setPonBoxLocations(ponBoxLocations);
              setPillarLocations(pillarLocations);
              setProblemLineLocations(data.value.problemLinePoint);
              
          } else {
              console.log('Данные не найдены или в неверном формате');
          }
      } catch (error) {
          console.error('Error fetching data:', error);
      }
  };

   // Преобразуем данные для полилиний
   const lines = listConnectionCable.map((cable) => ({
    
    key: cable.key,
    cableName: cable.cableName,
    positions: cable.coordinates.map(coord => [coord.latitude, coord.longitude]),
    color: cable.cableColor.trim(),
    width: cable.cableWidth,
    kind: cable.cableKind,
    type: cable.cableType,
    description: cable.description, 
    lengthCable: cable.lengthCable, 
    contractorName: cable.contractorName, 
    lengthAct: cable.lengthAct
    }));

    // считаем длинну от точки до начала и конца отрезка
    const handleLineClick = (e, line) => {
        const click = [e.latlng.lat, e.latlng.lng];

        const res = getDistanceOnLine(line.positions, click);

        setClickedPointInfo({
            point: [res.point.lat, res.point.lng],
            a: res.a,
            b: res.b,
            total: res.total
        });
        };


    // useEffect(() => {
    //     // Суммируем длины кабелей и округляем до 2 знаков после запятой
    //     const length = lines
    //         .reduce((sum, line) => sum + (line.lengthCable || 0), 0)
    //         .toFixed(1);
    
    //     setTotalLength(Number(length));
    // }, [lines]);
    useEffect(() => {
        // Суммируем длины кабелей с учетом условия
        const length = lines
            .reduce((sum, line) => {
                const lengthToAdd = line.lengthAct && !isNaN(Number(line.lengthAct)) && line.lengthAct.trim() !== "" 
                    ? Number(line.lengthAct) 
                    : (line.lengthCable || 0);
                return sum + lengthToAdd;
            }, 0)
            .toFixed(0);
    
        setTotalLength(Number(length));
    }, [lines]);

  const handleClose = () => {
    onClose();
    setListConnectionCable([]);
    setFobLocations([]);
    setCouplingLocations([]);
    setWellLocations([]);
    setPonBoxLocations([]);
    setPillarLocations([]);
    setProblemLineLocations([]);
    setInputId('');   
  };

  return (
    <Dialog open={open} className="modalStyle"  fullWidth maxWidth={false}>
      <DialogContent>
        <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset',textShadow: '2px 2px 4px #242424' }}>Маршрут линка</label>
        <hr className="horizontalLineModal" />
        <div>
             
          <input
            type="number"
            placeholder="ID кабеля"
            className="inputDescriptionModal"
            value={inputId}
            onChange={(e) => setInputId(e.target.value)}
          />

          <button className="buttonIsDescriptionModal" onClick={fetchData} style={{textShadow: '2px 2px 4px #242424'}}>Отобразить</button>
         
          <label className="address-summary"
                style={{
                    display: "initial",
                    width: "auto",
                    marginLeft: "20px",
                    color: '#cacaca', 
                    fontSize: '16px',
                    fontFamily: 'unset',
                    textShadow: '2px 2px 4px #242424'
                }}
            >
                Общая длина:{" "}
                 <span
                   style={{
                        color: '#dfab01', 
                   }}
                 >
                 {totalLength} м.
                 </span>
                </label>         
         </div>

       

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>

          <div style={{ height: '600px', width: '1140px', borderRadius: '10px', marginTop: '10px', flex: 2 }}>
          <MapContainer
               center={[50.45018, 30.52294]}
                zoom={13} 
                style={{ height: '590px', width: '100%', borderRadius: '10px' }}
                ref={mapRef}  
                doubleClickZoom={false}  

            >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  maxZoom={19.5} // Предел тайлов
                />
           
                {lines.map((line, index) => (
                   
                    <Polyline
                        key={index}
                        positions={line.positions}
                        color={line.color}
                        weight={line.width}
                        dashArray={line.kind !== 'solid ' ? '5,10' : null}   
                          eventHandlers={{
                            contextmenu: (e) => handleLineClick(e, line)
                            }}
                    > 

                    {clickedPointInfo && (
                        <Marker
                            position={clickedPointInfo.point}
                            icon={L.divIcon({
                            className: "click-marker",
                            html: `<div style="
                                width:14px;
                                height:14px;
                                background:yellow;
                                border:2px solid black;
                                border-radius:50%;
                            "></div>`
                            })}
                        >
                            
                          <Popup autoClose={false} className="custom-dark-popup">
                                <div
                                    style={{
                                    background: "#1e1e1e",
                                    color: "#eaeaea",
                                    padding: "12px 14px",
                                    borderRadius: "10px",
                                    minWidth: "220px",
                                    boxShadow: "0 10px 25px rgba(0,0,0,0.6)"
                                    }}
                                >
                                    <div
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#f5c542",
                                        marginBottom: "10px"
                                    }}
                                    >
                                    Положение на кабеле
                                    </div>

                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                                    <span style={{ color: "#aaa" }}>До точки A:</span>
                                    <span style={{ color: "#fff" }}>
                                        {clickedPointInfo.a.toFixed(1)} м
                                    </span>
                                    </div>

                                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                                    <span style={{ color: "#aaa" }}>До точки B:</span>
                                    <span style={{ color: "#fff" }}>
                                        {clickedPointInfo.b.toFixed(1)} м
                                    </span>
                                    </div>

                                    <div
                                    style={{
                                        borderTop: "1px solid #333",
                                        margin: "10px 0"
                                    }}
                                    />

                                    <div
                                    style={{
                                        textAlign: "center",
                                        fontWeight: "600",
                                        color: "#ffd884"
                                    }}
                                    >
                                    Всего: {clickedPointInfo.total.toFixed(1)} м
                                    </div>
                                </div>
                                </Popup>
                        </Marker>
                        )}     

                     <Tooltip
                        permanent
                        direction="center"
                        className="custom-tooltip"
                    >
                        <div
                            // onClick={() => handlePolylineClick(line.lineOpticId)}
                            style={{
                                color: line.color || 'black',
                                backgroundColor: 'transparent',
                                border: '1px solid silver',
                                borderRadius: '20px',
                                padding: '3px',
                                backgroundImage: 'linear-gradient(to right, #f0f0f0, #d0d0d0)',
                                margin: '0',
                                cursor: 'pointer',
                                pointerEvents: 'auto',
                            }}
                        >
                              {line.lengthAct && line.lengthAct.trim() !== "" && line.lengthAct !== "0"
                    ? `${line.lengthAct} м.`
                    : `${Math.floor(line.lengthCable)} м. ❗`}
                        </div>
                    </Tooltip>              

                        <Popup autoClose={false} className="custom-popup">
                        <div>
                        <label style={{fontSize: '16px' }}><span style={{ color: '#5e3f00', fontWeight: 'bold'  }}>{CABLE_FLAG} ID: {line.key}</span></label>
                        <hr className='horizontalLineModal'/>
                          <label style={{ fontSize: '13px' }}>
                              <span style={{ color: '#000000', fontWeight: 'bold' }}>{CABLE_FLAG}: </span>
                              <span style={{ color: '#363636' }}>{line.cableName}</span>
                          </label>              
                          <hr className="horizontalLinePopup" />
                          <label style={{ fontSize: '13px' }}>
                              <span style={{ color: '#000000', fontWeight: 'bold' }}>Тип: </span>
                              <span style={{ color: '#363636' }}>{line.type}</span>
                          </label>
                          <hr className="horizontalLinePopup" />
                          <label style={{ fontSize: '13px' }}>
                              <span style={{ color: '#000000', fontWeight: 'bold' }}>Длина: </span>
                              <span style={{ color: '#363636' }}>{line.lengthCable} м.</span>
                          </label> 
                          <hr className="horizontalLinePopup" />
                          <label style={{ fontSize: '13px' }}>
                              <span style={{ color: '#000000', fontWeight: 'bold' }}>Подрядчик: </span>
                              <span style={{ color: '#363636' }}>{line.contractorName}</span>
                          </label>                     
                          <hr className="horizontalLinePopup" />
                          <label style={{ fontSize: '13px' }}>
                              <span style={{ color: '#000000', fontWeight: 'bold' }}>Комент: </span>
                              <span style={{ color: '#363636' }}>{line.description}</span>
                          </label> 


                            
                        </div>
                      </Popup>        
                    </Polyline>     
                ))}

                 {/* Отображение точек Fob */}
       {fobLocations.map((location, index) => (
        
        <Marker
            key={index}
            position={[location.latitude, location.longitude]}
            icon={
                    location.rankComponentId === 1 || location.rankComponentId === 2
                        ? iconFob
                        : iconFobCanton
                }
        >
          <Popup autoClose={false} className="custom-popup">
              <div>
              <label style={{fontSize: '16px' }}><span style={{ color: '#5e3f00', fontWeight: 'bold'  }}>{FOB_FLAG} ID: {location.id}</span></label>
              <hr className='horizontalLineModal'/>
                <label style={{ fontSize: '13px' }}>
                    <span style={{ color: '#000000', fontWeight: 'bold' }}>{FOB_FLAG}: </span>
                    <span style={{ color: '#363636' }}>{location.fobName}</span>
                </label>
                <hr className="horizontalLinePopup" />
                <label style={{ fontSize: '13px' }}>
                    <span style={{ color: '#000000', fontWeight: 'bold' }}>Территория: </span>
                    <span style={{ color: '#363636' }}>{location.territory}</span>
                </label>
                <hr className="horizontalLinePopup" />
                <label style={{ fontSize: '13px' }}>
                    <span style={{ color: '#000000', fontWeight: 'bold' }}>Комент: </span>
                    <span style={{ color: '#363636' }}>{location.description}</span>
                </label> 
                     
              </div>
            </Popup>        
        </Marker>
    ))}

    {problemLineLocations.map((location, index) => (
        <Marker
            key={index}
            position={[location.latitude, location.longitude]}
            icon={iconProblem}
        >
           <Popup className="custom-popup">
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <img 
                  src="./problem.png" 
                  width="40" 
                  height="40" 
                  style={{ marginBottom: "5px" }} 
                  alt="pr"
                />
              </div>
              <span style={{ color: '#616161', fontWeight: 'bold', fontSize: '14px' }}>
                ID: <span style={{ color: 'black', fontWeight: 'normal' }}> {location.id}</span>
              </span>
              <br/>
              <span style={{ color: '#616161', fontWeight: 'bold', fontSize: '14px' }}>
                Тип: <span style={{ color: 'black', fontWeight: 'normal' }}> {location.problemName}</span>
              </span>
              <hr className='horizontalLineFilter' />
              <span style={{ fontWeight: 'bold', fontSize: '14px', color: '#616161' }}>Коммент:
              </span><span style={{ color: 'black', fontWeight: 'normal', fontSize: '13px' }}> {location.description} </span> <br />
              <hr className='horizontalLineFilter' />

            </Popup>
        </Marker>
    ))}

    {/* Отображение точек Coupling */}
    {couplingLocations.map((location, index) => (
        <Marker
            key={index}
            position={[location.latitude, location.longitude]}
            icon={
                    location.rankComponentId === 1 || location.rankComponentId === 2
                        ? iconCoupling
                        : iconCouplingCanton
                } 
        >
           <Popup autoClose={false} className="custom-popup">
              <div>
              <label style={{fontSize: '16px' }}><span style={{ color: '#5e3f00', fontWeight: 'bold'  }}>{COUPLING_FLAG} ID: {location.id}</span></label>
              <hr className='horizontalLineModal'/>
                <label style={{ fontSize: '13px' }}>
                    <span style={{ color: '#000000', fontWeight: 'bold' }}>{COUPLING_FLAG}: </span>
                    <span style={{ color: '#363636' }}>{location.couplingName}</span>
                </label>
                <hr className="horizontalLinePopup" />
                <label style={{ fontSize: '13px' }}>
                    <span style={{ color: '#000000', fontWeight: 'bold' }}>Территория: </span>
                    <span style={{ color: '#363636' }}>{location.territory}</span>
                </label>
                <hr className="horizontalLinePopup" />
                <label style={{ fontSize: '13px' }}>
                    <span style={{ color: '#000000', fontWeight: 'bold' }}>Комент: </span>
                    <span style={{ color: '#363636' }}>{location.description}</span>
                </label>            
              </div>
            </Popup>        
        </Marker>
    ))}

    {/* Отображение точек Well */}
    {wellLocations.map((location, index) => (
        <Marker
            key={index}
            position={[location.latitude, location.longitude]}
            icon={iconManhole}
            >
            <Popup autoClose={false} className="custom-popup">
               <div>
               <label style={{fontSize: '16px' }}><span style={{ color: '#5e3f00', fontWeight: 'bold'  }}>{WELL_FLAG} ID: {location.id}</span></label>
               <hr className='horizontalLineModal'/>
                 <label style={{ fontSize: '13px' }}>
                     <span style={{ color: '#000000', fontWeight: 'bold' }}>Территория: </span>
                     <span style={{ color: '#363636' }}>{location.territory}</span>
                 </label>
                 <hr className="horizontalLinePopup" />
                 <label style={{ fontSize: '13px' }}>
                     <span style={{ color: '#000000', fontWeight: 'bold' }}>Собственник: </span>
                     <span style={{ color: '#363636' }}>{location.ownerWell}</span>
                 </label>              
                 <hr className="horizontalLinePopup" />
                 <label style={{ fontSize: '13px' }}>
                     <span style={{ color: '#000000', fontWeight: 'bold' }}>Комент: </span>
                     <span style={{ color: '#363636' }}>{location.description}</span>
                 </label>            
               </div>
             </Popup>        
         </Marker>
    ))}

     {/* Отображение точек Pon-box */}
     {ponBoxLocations.map((location, index) => (
        <Marker
            key={index}
            position={[location.latitude, location.longitude]}
            icon={iconPonBox}
            >
            <Popup autoClose={false} className="custom-popup">
               <div>
               <label style={{fontSize: '16px' }}><span style={{ color: '#5e3f00', fontWeight: 'bold'  }}>{PON_BOX_FLAG} ID: {location.id}</span></label>
               <hr className='horizontalLineModal'/>
                 <label style={{ fontSize: '13px' }}>
                     <span style={{ color: '#000000', fontWeight: 'bold' }}>Территория: </span>
                     <span style={{ color: '#363636' }}>{location.territory}</span>
                 </label>
                 <hr className="horizontalLinePopup" />
                 <label style={{ fontSize: '13px' }}>
                     <span style={{ color: '#000000', fontWeight: 'bold' }}>Пон-бокс: </span>
                     <span style={{ color: '#363636' }}>{location.ponBoxName}</span>
                 </label>              
                 <hr className="horizontalLinePopup" />
                 <label style={{ fontSize: '13px' }}>
                     <span style={{ color: '#000000', fontWeight: 'bold' }}>Комент: </span>
                     <span style={{ color: '#363636' }}>{location.description}</span>
                 </label>            
               </div>
             </Popup>        
         </Marker>
    ))}

     {/* Отображение точек Pillar */}
     {pillarLocations.map((location, index) => (
        <Marker
            key={index}
            position={[location.latitude, location.longitude]}
            icon={iconPillar}
            >
            <Popup autoClose={false} className="custom-popup">
               <div>
               <label style={{fontSize: '16px' }}><span style={{ color: '#5e3f00', fontWeight: 'bold'  }}>{PILLAR_FLAG} ID: {location.id}</span></label>
               <hr className='horizontalLineModal'/>
                 <label style={{ fontSize: '13px' }}>
                     <span style={{ color: '#000000', fontWeight: 'bold' }}>Территория: </span>
                     <span style={{ color: '#363636' }}>{location.territory}</span>
                 </label>
                 <hr className="horizontalLinePopup" />
                 <label style={{ fontSize: '13px' }}>
                     <span style={{ color: '#000000', fontWeight: 'bold' }}>Собственник: </span>
                     <span style={{ color: '#363636' }}>{location.ownerPillar}</span>
                 </label>              
                 <hr className="horizontalLinePopup" />
                 <label style={{ fontSize: '13px' }}>
                     <span style={{ color: '#000000', fontWeight: 'bold' }}>Комент: </span>
                     <span style={{ color: '#363636' }}>{location.description}</span>
                 </label>            
               </div>
             </Popup>        
         </Marker>
    ))}
            </MapContainer>
        
    </div> 
  </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} class='buttonIsHideModal'>
          Закрыть
        </Button>
      </DialogActions>    
    </Dialog>
  );
}

export default ModalRouteCableMap;